import React, { useEffect, useState, useRef } from 'react';
import { Box } from '@mui/material';
import theme from '../../theme';
import logo from '../../assets/logo_black.png';
import { useUserStore } from '../../stores/userStore';
import { trackAdsenseClick } from '../../lib/gaEvents';

export const AD_SLOT = {
  BOTTOM_STICKY: '7707227171',
  MYPAGE_INFEED: '4470689744',
  MYPAGE_RIGHT_STICKY: '4469195487',
  NOTIFICATION_RIGHT_STICKY: '5590705461',
  NOTICE_POST_INFEED: '8187842391',
  NOTICE_POST_RIGHT_STICKY: '6874760722',
  NOTICE_INFEED: '9784286670',
  NOTICE_RIGHT_STICKY_1: '3123217973',
  NOTICE_RIGHT_STICKY_2: '6780926808',
  LISTS_POST_INFEED: '5055246747',
  LISTS_POST_RIGHT_STICKY: '7892328924',
  LISTS_INFEED: '5266165582',
  LISTS_RIGHT_STICKY: '6872426140',
  NEWS_POST_INFEED: '2933181131',
  NEWS_POST_RIGHT_STICKY: '2429083407',
  NEWS_RIGHT_STICKY: '1718636963',
  NEWS_INFEED_1: '2841681794',
  NEWS_INFEED_2: '3163580577',
  REVIEWS_INFEED: '7266477114',
  REVIEWS_POST_LEFT_STICKY: '3943010475',
  REVIEWS_RELATED_RIGHT_STICKY: '5635800867',
  REVIEWS_POST_INFEED: '5953395442',
  REVIEWS_USERREVIEWS_INFEED: '3327232103',
  REVIEWS_USERREVIEWS_RIGHT_STICKY: '6338340571',
  REVIEWS_DETAIL_INFEED: '8401397135',
  REVIEWS_DETAIL_RIGHT_STICKY: '7088315462',
  ARTIST_RIGHT_STICKY: '5839611738',
  ARTIST_MORE_INFEED: '4342697239',
  ARTIST_MORE_RIGHT_STICKY: '5655778905',
  SEARCH_INFEED_1: '8531252431',
  SEARCH_INFEED_2: '9373560816',
  SEARCH_RIGHT_STICKY: '3008733566',
  SEARCH_MORE_INFEED: '6330566329',
  SEARCH_MORE_RIGHT_STICKY: '1844526403',
  HOME_RIGHT_STICKY: '8246283225',
  HOME_INFEED: '9020308841',
  HOME_REVIEW_INCONTENT_1: '9844334108',
  HOME_REVIEW_INCONTENT_2: '2999724152',
};

const GoogleAdSense = ({ adSlot, adType, pageType, sx: sxProp }) => {
  const [adFailed, setAdFailed] = useState(false);
  const adRef = useRef(null);
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (!adType) return;

    const handleBlur = () => {
      if (adRef.current && adRef.current.contains(document.activeElement)) {
        trackAdsenseClick({ adType, pageType }, user);
      }
    };

    window.addEventListener('blur', handleBlur);
    return () => window.removeEventListener('blur', handleBlur);
  }, [adType, pageType, user]);

  useEffect(() => {
    const img = new Image();
    img.src = logo;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      setAdFailed(true);
      return;
    }

    const checkAdFailed = (ad) => {
      const status = ad.getAttribute('data-ad-status');
      return (
        (!ad.querySelector('iframe') && ad.offsetHeight === 0) ||
        status === 'unfilled' ||
        ad.innerHTML.trim() === ''
      );
    };

    let observer;
    if (adRef.current) {
      observer = new MutationObserver(() => {
        if (adRef.current && checkAdFailed(adRef.current)) {
          setAdFailed(true);
          observer.disconnect();
        }
      });
      observer.observe(adRef.current, { attributes: true, childList: true, subtree: true });
    }

    const timer = setTimeout(() => {
      if (adRef.current && checkAdFailed(adRef.current)) {
        setAdFailed(true);
      }
      observer?.disconnect();
    }, 1500);

    return () => {
      clearTimeout(timer);
      observer?.disconnect();
    };
  }, []);

  if (adFailed) {
    if (process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION') return null;
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.grey.bg,
          ...sxProp,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Postpop"
          sx={{ width: '30%', maxWidth: 120, opacity: 0.3 }}
        />
      </Box>
    );
  }

  return (
    <Box
      ref={adRef}
      component="ins"
      className="adsbygoogle"
      data-ad-client="ca-pub-1489490832448293"
      data-ad-slot={adSlot}
      sx={{
        display: 'block',
        ...sxProp,
      }}
    />
  );
};

export default GoogleAdSense;
